export default {
  error: {
    0: "Oops! ホームページが見つかりません",
    返回首页: "ホームページに戻る",
    返回上一页: "前のページに戻る",
  },
  DF: {
    0: "<strong>Authingには500以上のオープンインターフェースがあります。</strong>Authing は、RESTful と GraphQL のほか、Python、JavaScript、Node、PHP、Java、Swift、Rust などのプログラミング言語やフレームワークをサポートしており、Web、iOS、Android、その他のバックエンドプラットフォームのニーズに対応しています。Authing は Serverless アーキテクチャを完全にサポートし、安全なシングルサインオンと認証のために Serverless と安全に互換性のある OIDC フレームワークを持っています。 <br />  <br /> 自動化は、多言語、クロスプラットフォーム、直感的でユーザーフレンドリーな豊富な SDK によってサポートされています。 詳しくはこちら。",
    1: 'Authing は Oddo Wordpress c9.io Strapi と他の主流のビジネスヘッドのオープンソースソフトウェアと互換性があり、大幅に企業と個々の開発者の両方のためのワークロードの使用へのアクセスを減らすことができます。<br /><br />Authingは、OAuth2.0 OIDC SAML AD/LDAP JWT CAS SWAなどの主流の認証プロトコルをすべてサポートしており、SoLiDプロジェクトのアジアノードオペレータです。（もっと詳しく：<a href="https://solidproject.org/" target="_blank"  >https://solidproject.org/</a>）',
    开发者友好: "開発者に優しい",
  },
  FV: {
    0: "Authing は、完全かつ簡単にデータをエクスポートできる機能を提供しており、ユーザーはいつでもプラットフォームからデータを完全に移行することができます。Authing はユーザーデータを一切保持しません。",
    1: "Authing は、OIDC、SAML、OAuth など、市場に出回っている主要なプロトコルをすべてサポートしているので、お客様は自由に選択することができます。",
    2: "Authing はカスタマイズ可能な認証プロセス（Pipeline）をサポートしており、お客様が認証プロセスを変更したり、招待コードの登録ロジックなどの必要な機能をプラグアンドプレイしたり、ログインに動的認証を必要とするモジュールを削除したりなど、Pipelineはこれらすべてのシナリオに迅速に対応することができます。",
    无供应商锁定: "ベンダーロックインなし",
    导出数据: "データをエクスポートする",
    标准协议: "標準プロトコル",
    自定义流程: "カスタマイズプロセス",
  },
  HP: {
    0: "Authing プラットフォームは、何十億人ものユーザーをサポートするために、弾力的に拡張できるように設計されています。",
    1: "Authing は弾力的にインフラをスケーリングするクロスクラウドのインフラを持っています。インフラは単一障害点、冗長アーキテクチャ、冗長ストレージがありません。",
    2: "毎月8カ国から何百万人もの人々がAuthingプラットフォームを利用して認証サービスを利用しており、Authingは企業のセキュリティと人件費を数百万ドル削減し、新機能開発にかかる時間を23%削減しています。",
    3: "AWS は、Amazon が作成したクラウドコンピューティングプラットフォームで、個人、企業、政府などに、ストレージ、データベース、コンピューティング、機械学習などの情報技術インフラとアプリケーションを含む様々なサービスを提供しています。",
    4: "六王朝の古都南京に位置する東南大学は、世界で最も有名な大学の一つです。",
    高性能: "高性能",
  },
  PD: {
    0: "Authing は、企業のニーズに合わせてカスタマイズされたプライベートデプロイメントソリューションを提供し、アイデンティティ管理を容易にします。 プロの技術者がソリューションの導入から販売後までの全プロセスに関与し、完全な顧客サービスを提供しています。",
    1: "1954年5月に設立された高等教育出版社は、新中国で最も早い時期に設立された専門的な教育出版機関の一つです。 1700人以上のスタッフを擁し、年間1万冊以上の書籍を発行し、発行部数は1億3000万部。",
    咨询顾问: "コンサルタント",
    支持私有部署: "プライベート展開のサポート",
  },
  SC: {
    0: "Authing は、非対称暗号化 RSA と鍵インフラストラクチャ KMS を介してすべてのデータの保存と伝送を暗号化し、ユーザーだけがすべての生データにアクセスできるようにし、カスタムパスワードの強度と暗号化アルゴリズムをサポートし、複数のアンチバーストと悪意のある登録メカニズムを備え、MFA の多要素認証とワンタイムパスワードOTAでアイデンティティセキュリティを処理します。",
    1: "Authing は<strong>RBAC と ABAC</strong>をサポートし、あらゆるタイプのアクセス制御のニーズに確実に対応します。",
    高安全: "ハイセキュリティ",
    了解更多: "もっと詳しく",
  },
  SI: {
    0: "Authing<br />  はアイデンティティ管理を簡単にします。",
    1: " 2B、B2C、B2E、IoT のいずれのシナリオにおいても、優れたアイデンティティ管理ソリューションを提供するプロバイダーとしての Authing の役割は、開発コストの削減、セキュリティの向上、生産性の向上など、企業に大きな競争上の優位性をもたらします。",
    免费使用: "無料アクセス",
  },
  SS: {
    0: "Authing はカスタマイズとプライベートデプロイをサポートしています。 ソリューションチームは、ビジネス要件をカスタマイズするプロセス全体をフォローアップし、エンタープライズデータのセキュリティと制御のためにローカルサーバーを展開することができます。",
    1: "カスタマーサクセスチームは、インターフェースのインターフェイス、テスト、ゴーライブから、その後のシステム運用・保守、管理プラットフォームの利用まで、7*24時間の継続的なサービスを提供しています。",
    确保你的成功是我们的工作: "あなたを成功させるのが私たちの仕事です。",
  },
  BF: {
    0: "ワンステップでサインアップして、8000 個の無料認定をお楽しみください。",
    免费使用Authing: "無料アクセス",
    免费使用: "無料アクセス",
    查看详情: "もっと詳しく",
  },
  CS: {
    0: "オンラインエディタがロード中です、お待ちください...",
  },
  CF: {
    0: "Authing は28以上の業界にハンズオンソリューションを輸出しており、その経験をお客様と共有し、無料のデモを提供しています。",
    1: "また、WeChatや携帯電話で直接営業担当者に連絡することも可能です。",
    获得企业级解决方案: "企業クラスのソリューションへのアクセス",
    你的名字: "名前",
    希望我们如何称呼你: "お名前は？",
    手机: "携帯電話番号",
    我们的顾问将尽快致电你: "相談員がすぐにお電話をさせていただきます。",
    备注信息: "付記",
    立刻提交: "今すぐ送信",
    请输入你的姓名: "お名前を入力してください",
    请输入你的手机号: "携帯電話番号を入力してください",
    请输入合法的手机号: "有効な携帯電話番号を入力してください。",
    提交成功: "送信されました",
    我们的顾问将在三日内致电你: "3日以内にコンサルタントがお電話をさせていただきます。",
  },
  IN: {
    0: "企業の生産性を向上させるために、さまざまな産業やアプリケーション分野の専門的なソリューションを提供しています。",
    1: "市民が1つのアカウントですべてのシステムにアクセスし、政府のサービスに安全にログインできるようにします。",
    2: "読者が読書に集中できるように、配信、著者、編集者、すべてが指先でできるようになります。",
    3: "権限を与えられた金融クラウド、直観的で視覚的な分析プラットフォームは、国の規制基準に準拠しています。",
    4: "プレイヤーを早く来させて、ハッカーをポイントから遠ざけましょう。複数の ID ソースからの迅速なログインにより、ユーザーの機密情報へのアクセスを確実にします。",
    5: "1つの認証多地点相互接続 1つのソフトウェアグローバル監視",
    6: "WiFi、キャンパスカード、1つのネットワークで学生とスタッフを保護する",
    行业解决方案: "産業別ソリューション",
    免费使用: "無料アクセス",
    查看文档: "ドキュメントを見る",
    了解更多: "もっと詳しく >>",
    政府: "政府",
    出版: "出版",
    金融: "金融",
    游戏: "ゲーム",
    软件业: "ソフトウェア",
    教育: "教育",
  },
  RE: {
    了解详情: "もっと詳しく",
  },
  CU: {
    0: "Authing Identity Cloud は、組織がコアビジネスに集中できるように、外部ユーザーアカウントと内部の従業員の権限を安全かつ効率的に管理することを支援します。",
    1: "Authing シングルサインオンは、IDシステムを効率的に管理するのに役立ちます。 認可されたすべてのオフィスソフトウェア、ソーシャルプラットフォーム、オンプレミスシステムへのシングルサインオンアクセスは、ユーザーエクスペリエンスを大幅に向上させます。",
    2: "Authing ログインコンポーネントは、ログインロジックコードを書く負担を軽減し、数行のコードでログイン登録フォームを即座に生成します。 また、Authing SDK を使ってフォームをカスタマイズすることもできます。",
    3: "Authing 多要素認証は、SMS 認証コードログイン、メールボックス認証ログイン、指紋認証ログイン、QR コードスキャン認証ログインなどの認証方法に対応しています。",
    4: "Authing ダッシュボードはユーザー情報管理、ユーザーの権利管理、ユーザーのセキュリティ情報監査、ユーザー データ分析、等を統合します。",
    构建适合你的IAM解决方案: "適した IAM ソリューションを構築します",
    单点登录: "シングルサインオン",
    了解更多: "もっと詳しく",
    登录组件: "ログイン コンポーネント",
    多因素认证: "多要素認証",
    用户管理: "ユーザー管理",
  },
  FO: {
    0: "北京市海淀区成府路 45 号中关村智造大街 G 座",
    1: "京ICP备19051205号-7",
    公司: "会社",
    关于我们: "私たちについて",
    用户中心: "ユーザーセンター",
    技术博客: "技術ブログ",
    产品优势: "製品のメリット",
    加入我们: "参加する",
    服务状态: "サービス状況",
    求职信息: "就職情報",
    开放平台: "オープンプ ラットフォーム",
    OpenAPI: "Open API",
    开发资源: "開発者のリソース",
    常见问题: "FAQ",
    集成案例: "統合ケース",
    技术支持: "技術支援",
    开发者社区: "開発者コミュニティ",
    联系我们: "お問い合わせ",
    微信咨询: "WeChat",
    北京蒸汽记忆科技有限公司: "北京蒸気記憶技術有限会社",
  },
  IM: {
    Authing的优势: "Authing のメリット",
    用户身份管理: "ユーザー ID 管理",
    集成第三方登录: "統合されたサードパーティのログイン",
    手机号码闪验: "携帯電話番号で検証",
    通用登录组件: "ユニバーサル ログイン フォーム コンポーネント",
    自定义认证流程: "カスタマイズされた認証プロセス",
    企业内部管理: "社内管理",
    单点登录: "シングルサインオン",
    多因素认证: "多要素認証",
    权限管理: "許可管理",
  },
  MH: {
    免费使用: "無料アクセス",
    快速安全的云身份认证: "高速で安全なアイデンティティ認証",
    查看文档: "ドキュメントを見る",
    首页: "ホームページ",
    产品介绍: "製品の説明",
    用户身份管理: "ユーザー ID 管理",
    集成微信登录: "統合された WeChat のログイン",
    自定义认证流程: "カスタマイズされた認証プロセス",
    登录组件: "ログインコンポーネント",
    企业内部管理: "社内管理",
    单点登录: "シングルサインオン",
    多因素认证: "多要素認証",
    权限管理: "許可管理",
    资源: "リソース",
    开发文档: "開発文書",
    博客: "ブログ",
    用户中心: "ユーザーセンター",
    定价: "価額",
  },
  PC: {
    产品介绍: "製品の説明",
    开发文档: "開発文書",
    Demo索引: "Demo インデックス",
    安全与合规: "セキュリティとコンプライアンス",
    社区支持: "コミュニティ サポート",
    联系我们: "お問い合わせ",
    登录: "ログイン",
    了解更多: "もっと詳しく",
  },
  RM: {
    博客: "ブログ",
    用户中心: "ユーザーセンター",
  },
  UM: {
    控制台: "ダッシュボード",
    个人中心: "パーソナルセンター",
    退出: "ログアウト",
    退出成功: "ログアウトに成功した",
  },
};
